import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { PureComponent } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush } from 'recharts';
import { hex2rgba } from 'src/utils/colors';
import { currencyFormatter } from 'src/utils/translator';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
const colors = {
  paid: hex2rgba('#259D58', 0.5),
  unpaid: hex2rgba('#C43131', 0.5),
  credited: hex2rgba('#2A85D1', 0.5),
  brush: hex2rgba('#FFFFFF', 0.75)
};

// const barSize = 40;
const maxBarSize = 60;
class BarChartPaidUnpaid extends PureComponent {
  constructor(props) {
    super(props);
    this.state = _objectSpread(_objectSpread({}, props), {}, {
      data: props.data
    });
  }
  render() {
    var _this$props;
    const t = this.props.t;
    const CustomTooltip = _ref => {
      let active = _ref.active,
        payload = _ref.payload;
      if (active && payload && payload.length) {
        var _payload$, _payload$2, _payload$3, _payload$4, _payload$5, _paid$payload, _credited$payload, _unpaid$payload;
        const paid = payload.find(i => i.dataKey === 'paid');
        const credited = payload.find(i => i.dataKey === 'credited');
        const unpaid = payload.find(i => i.dataKey === 'unpaid');
        const paragraphStyles = {
          padding: 0,
          margin: 0,
          color: '#ffffff',
          display: 'flex',
          alignItems: 'center'
        };
        const coloredSquareStyles = color => {
          return {
            display: 'block',
            width: '16px',
            height: '16px',
            borderRadius: '2px',
            marginRight: '5px',
            opacity: '0px',
            background: color
          };
        };
        return /*#__PURE__*/React.createElement("div", {
          // className={classes.customTooltip}
          style: {
            backgroundColor: '#212934',
            border: '1px solid #212934',
            padding: '5px',
            margin: 0
          }
        }, /*#__PURE__*/React.createElement("p", {
          className: "label",
          style: {
            padding: 0,
            margin: 0,
            color: '#ffffff'
          }
        }, /*#__PURE__*/React.createElement("b", null, "".concat(((_payload$ = payload[0]) === null || _payload$ === void 0 || (_payload$ = _payload$.payload) === null || _payload$ === void 0 ? void 0 : _payload$.propertyName) || moment((_payload$2 = payload[0]) === null || _payload$2 === void 0 || (_payload$2 = _payload$2.payload) === null || _payload$2 === void 0 ? void 0 : _payload$2.startDateOnly).format('MMMM YYYY') || ((_payload$3 = payload[0]) === null || _payload$3 === void 0 || (_payload$3 = _payload$3.payload) === null || _payload$3 === void 0 ? void 0 : _payload$3.label)))), ((_payload$4 = payload[0]) === null || _payload$4 === void 0 || (_payload$4 = _payload$4.payload) === null || _payload$4 === void 0 ? void 0 : _payload$4.unitName) && /*#__PURE__*/React.createElement("p", {
          className: "label",
          style: {
            padding: 0,
            margin: 0,
            color: '#ffffff'
          }
        }, /*#__PURE__*/React.createElement("b", null, "Unit: ", "".concat((_payload$5 = payload[0]) === null || _payload$5 === void 0 || (_payload$5 = _payload$5.payload) === null || _payload$5 === void 0 ? void 0 : _payload$5.label))), /*#__PURE__*/React.createElement("p", {
          // className={classes.descTotalCurrency}
          style: _objectSpread({}, paragraphStyles)
        }, /*#__PURE__*/React.createElement("div", {
          style: _objectSpread({}, coloredSquareStyles('#259D58'))
        }), t('reimbursement_dashboard.reimbursed'), ": ", currencyFormatter(paid === null || paid === void 0 || (_paid$payload = paid.payload) === null || _paid$payload === void 0 ? void 0 : _paid$payload.paid)), /*#__PURE__*/React.createElement("p", {
          // className={classes.descTotalCurrency}
          style: _objectSpread({}, paragraphStyles)
        }, /*#__PURE__*/React.createElement("div", {
          style: _objectSpread({}, coloredSquareStyles('#2A85D1'))
        }), t('reimbursement_dashboard.credited'), ": ", currencyFormatter(credited === null || credited === void 0 || (_credited$payload = credited.payload) === null || _credited$payload === void 0 ? void 0 : _credited$payload.credited)), /*#__PURE__*/React.createElement("p", {
          style: _objectSpread({}, paragraphStyles)
        }, /*#__PURE__*/React.createElement("div", {
          style: _objectSpread({}, coloredSquareStyles('#C43131'))
        }), t('reimbursement_dashboard.unpaid'), ": ", currencyFormatter(unpaid === null || unpaid === void 0 || (_unpaid$payload = unpaid.payload) === null || _unpaid$payload === void 0 ? void 0 : _unpaid$payload.unpaid)));
      }
      return null;
    };
    return /*#__PURE__*/React.createElement(ResponsiveContainer, {
      width: "100%",
      height: "100%"
    }, /*#__PURE__*/React.createElement(BarChart, {
      width: 500,
      height: 300,
      data: this.props.data,
      margin: {
        top: 10,
        right: 15,
        left: 15,
        bottom: 10
      },
      isAnimationActive: false
    }, /*#__PURE__*/React.createElement(CartesianGrid, {
      strokeDasharray: "0 0"
    }), /*#__PURE__*/React.createElement(XAxis, {
      dataKey: "label"
    }), /*#__PURE__*/React.createElement(YAxis, {
      tickFormatter: value => {
        return "".concat(currencyFormatter(value, undefined, {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0
        }));
      }
    }), /*#__PURE__*/React.createElement(Tooltip, {
      content: /*#__PURE__*/React.createElement(CustomTooltip, null),
      cursor: {
        fill: 'transparent'
      }
    }), /*#__PURE__*/React.createElement(Legend, null), ((_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.data) === null || _this$props === void 0 ? void 0 : _this$props.length) >= 10 && /*#__PURE__*/React.createElement(Brush, {
      dataKey: "label",
      height: 20,
      stroke: "#009299"
    }), /*#__PURE__*/React.createElement(Bar, {
      maxBarSize: maxBarSize,
      name: t('reimbursement_dashboard.reimbursed'),
      displayName: t('reimbursement_dashboard.reimbursed'),
      dataKey: "paid",
      stackId: "period",
      fill: colors.paid,
      isAnimationActive: false
    }), /*#__PURE__*/React.createElement(Bar, {
      maxBarSize: maxBarSize,
      name: t('reimbursement_dashboard.credited'),
      displayName: t('reimbursement_dashboard.credited'),
      dataKey: "credited",
      stackId: "period",
      fill: colors.credited,
      isAnimationActive: false
    }), /*#__PURE__*/React.createElement(Bar, {
      maxBarSize: maxBarSize,
      name: t('reimbursement_dashboard.unpaid'),
      displayName: t('reimbursement_dashboard.unpaid'),
      dataKey: "unpaid",
      stackId: "period",
      fill: colors.unpaid,
      isAnimationActive: false
    })));
  }
}
export default withTranslation()(BarChartPaidUnpaid);